import { render, staticRenderFns } from "./DashboardTemplatePeriod.vue?vue&type=template&id=0230786c&scoped=true&"
import script from "./DashboardTemplatePeriod.vue?vue&type=script&lang=js&"
export * from "./DashboardTemplatePeriod.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTemplatePeriod.vue?vue&type=style&index=0&id=0230786c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0230786c",
  null
  
)

export default component.exports